import { Button } from "@npco/zeller-design-system";
import type { ReactElement } from "react";

export namespace Prompt {
	export type Props = {
		image: ReactElement;
		title?: string;
		datapoint?: string;
		subtitle?: string;
		message?: string | Array<string>;
		action?: Action | undefined;
	};

	export type Action =
		{ label: string; onClick: (() => void) | string } | undefined;
}

export function Prompt({
	image,
	title,
	datapoint,
	subtitle,
	message,
	action,
}: Prompt.Props) {
	const messages = Array.isArray(message) ? message : [message];
	return (
		<div className="flex h-full flex-col items-center justify-center gap-32 text-center px-32">
			<div className="flex items-center justify-center">{image}</div>
			<div className="flex flex-col space-y-16">
				<h1 className="text-2xl/heading h-[32px]">{title}</h1>
				<div className="text-lg h-[24px] space-y-16">
					{datapoint && <h2 className="text-2xl/heading">{datapoint}</h2>}
					{subtitle && <h2 className="text-lg text-grey-550">{subtitle}</h2>}
					{messages.map((message, i) => (
						<div key={i}>{message}</div>
					))}
				</div>
			</div>
			<div className="h-[48px]">
				{action &&
					(typeof action.onClick === "string" ? (
						<a href={action.onClick}>
							<Button label={action.label} onClick={undefined} />
						</a>
					) : (
						<Button label={action.label} onClick={action.onClick} />
					))}
			</div>
		</div>
	);
}
